import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { ANONYMIZE_MODE } from "@lib/enums";

const STORAGE_KEY = "floats:displaySettings";

const defaultState = {
  teamDashboard: {
    statsRange: { preset: "7d", from: null, to: null },
    chartRange: { preset: "7d", from: null, to: null },
    tableRange: { preset: "30d", from: null, to: null },
  },
  anonymizeMode: ANONYMIZE_MODE.NAME_AND_COMPANY,
  // Whether to attach the recruiter's terms document, remembered per send type
  includeTerms: {
    floats: false,
    submissions: false,
  },
};

export const useDisplaySettings = create()(
  persist(
    (set) => ({
      ...defaultState,

      setStatsRange: (range) =>
        set((state) => ({
          teamDashboard: { ...state.teamDashboard, statsRange: range },
        })),

      setTeamChartRange: (range) =>
        set((state) => ({
          teamDashboard: { ...state.teamDashboard, chartRange: range },
        })),

      setTeamTableRange: (range) =>
        set((state) => ({
          teamDashboard: { ...state.teamDashboard, tableRange: range },
        })),

      setAnonymizeMode: (mode) => set({ anonymizeMode: mode }),

      setIncludeTerms: (scope, include) =>
        set((state) => ({
          includeTerms: { ...state.includeTerms, [scope]: include },
        })),

      resetDisplaySettings: () => set(defaultState),
    }),
    {
      name: STORAGE_KEY,
      version: 4,
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        teamDashboard: state.teamDashboard,
        anonymizeMode: state.anonymizeMode,
        includeTerms: state.includeTerms,
      }),
      migrate: (persistedState) => ({
        ...persistedState,
        teamDashboard: {
          ...defaultState.teamDashboard,
          ...persistedState?.teamDashboard,
        },
        anonymizeMode: persistedState?.anonymizeMode ?? defaultState.anonymizeMode,
        includeTerms: {
          ...defaultState.includeTerms,
          ...persistedState?.includeTerms,
        },
      }),
    }
  )
);
